import { render } from "./LiderComponent.vue?vue&type=template&id=28b3ab38&scoped=true"
import script from "./LiderComponent.vue?vue&type=script&lang=js"
export * from "./LiderComponent.vue?vue&type=script&lang=js"

import "./LiderComponent.vue?vue&type=style&index=0&id=28b3ab38&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b3ab38"]])

export default __exports__